import '../../global.less';
import { useScroll } from 'ahooks';
import { NavLink, useRouteMatch } from '@modern-js/runtime/router';
import classNames from 'classnames';
import styles from './index.module.less';
import TUCHON_ICON from '@/assets/tuchong.png';
import IC_ICON from '@/assets/ic.svg';

interface NavItem {
  name: string;
  path: string;
  key: string;
  subNav?: NavItem[];
}

const NAV: NavItem[] = [
  {
    name: '首页',
    path: '/',
    key: 'home',
  },
  {
    name: '开发文档',
    path: '/doc',
    key: 'doc',
    subNav: [
      {
        name: '接入指南',
        path: '/doc/guide',
        key: 'guide',
      },
      {
        name: '创意类接口文档',
        path: '/doc/creative',
        key: 'creative',
      },
      {
        name: '新闻类接口文档',
        path: '/doc/news',
        key: 'news',
      },
    ],
  },
  {
    name: '客户支持',
    path: '/support',
    key: 'support',
    subNav: [
      {
        name: '联系我们',
        path: '/support/concat',
        key: 'concat',
      },
      {
        name: '技术问题',
        path: '/support/tech',
        key: 'tech',
      },
      {
        name: '使用问题',
        path: '/support/faq',
        key: 'faq',
      },
    ],
  },
  {
    name: '经典案例',
    path: '/classic',
    key: 'classic',
  },
];

const Header = () => {
  const position = useScroll(document);
  const router = useRouteMatch();
  const withoutBackground =
    position && position.top < 10 && router.path === '/';
  const classicBackground =
    router.path === '/classic' && position && position?.top < 10;
  return (
    <div
      className={classNames(styles.container, {
        [styles.classicBgc]: classicBackground,
      })}
      style={{
        backgroundColor: withoutBackground ? undefined : '#1C2030',
      }}
    >
      <div className={styles.logo}>
        <img src={TUCHON_ICON} className={styles.tuchong} />
        <div className={styles.divider}></div>
        <img src={IC_ICON} className={styles.ic} />
        <div className={styles.divider}></div>
        <h2 className={styles.title}>开放平台API</h2>
      </div>
      <nav className={styles.nav}>
        {NAV.map(item => (
          <li
            key={item.key}
            className={classNames(styles.navItem, { [styles.showSub]: true })}
          >
            <NavLink
              exact={item.path === '/'}
              to={item.path}
              className={isActive =>
                `${styles.navLink} ${isActive ? styles.active : ''}`
              }
            >
              <span>{item.name}</span>
            </NavLink>
            {item.subNav && router.path === '/' && (
              <div className={styles.subNav}>
                {item.subNav.map(sub => (
                  <NavLink
                    key={sub.key}
                    exact={true}
                    to={sub.path}
                    className={isActive => (isActive ? styles.subActive : '')}
                  >
                    {sub.name}
                  </NavLink>
                ))}
              </div>
            )}
          </li>
        ))}
      </nav>
    </div>
  );
};

export default Header;
